var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Printer Friendly View")]),_c('v-btn',{staticClass:"no-print",attrs:{"color":"primary"},on:{"click":_vm.print}},[_vm._v("Print")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }